import checkFormat from '@/utils/checkFormat'
import { Toast } from 'vant'
import api from '@/api/api.js'
import configure from '@/api/configure.js'

export const checkMixin = {
  data() {
    return {
      isQD: false, // 是否是青岛机构
      comCode: '', // 机构代码
      isChange: false
    }
  },
  methods: {
    checkQD() {
      const UserInfo = JSON.parse(localStorage.getItem('setPersonUserInfo'))
      this.isQD = UserInfo.salesmanInfoDto.comCode.startsWith('23702')
      this.comCode = UserInfo.salesmanInfoDto.comCode
    },
    getTaxRegistryNumber() {
      return new Promise((resolve, reject) => {
        this.$http.get(`${api.getTaxRegistryNumber}?comCode=${this.comCode}`).then(TaxRes => {
          if (TaxRes.data.rtnCode === '0000' && TaxRes.data.data) {
            this.taxRelifInfo.taxRegistryNumber = TaxRes.data.data
            this.OldTaxRegistryNumber = this.taxRelifInfo.taxRegistryNumber
            this.IsTaxRegistryNumber = false
            resolve(true)
          } else {
            this.IsTaxRegistryNumber = true
            reject(false)
          }
        })
      })
    },
    onBeforeClose(action, done) {
      if (action === 'confirm') {
        if (!this.taxRelifInfo.taxRegistryNumber) {
          return done(false)
        } else {
          return done()
        }
      } else {
        return done()
      }
    },
    taxNumConfirm() {
      if (this.taxRelifInfo.taxRegistryNumber) {
        this.OldTaxRegistryNumber = this.taxRelifInfo.taxRegistryNumber
        this.baoJia()
      }
    },
    queryProducts(agentCode, businessNature) {
      this.adds += 1
      const params = {
        isPersonal: this.$store.state.recognizeeIn.insuredNature === '4' ? '0' : '1', // 被保人是否为个人 1-个人 0-非个人
        businessNature: businessNature, // 业务来源
        seatCount: this.$store.state.vehicleInfos.seatCount, // 座位数限制
        useNature: this.$store.state.vehicleInfos.useNatureCode, // 车辆使用性质
        carKindCode: this.$store.state.vehicleInfos.carKindCode
      }
      this.$http.post(api.queryProductList, params).then(res => {
        if (res.data.rtnCode === '0000') {
          const newProductXInfoDTOList = res.data.productXInfoDTOList
          const saveArr = this.$store.state.carPolicySubInfoList.concat(this.$store.state.attachRiskList)
          newProductXInfoDTOList.forEach(ele => {
            ele.imgSrc = 'https://open.zking.com/cms/uploads/15/image/product' + ele.imgSrc
            if (saveArr && saveArr.length > 0) {
              const FI = saveArr.find(e => e.productCode === ele.productCode)
              FI ? ele.flag = true : ele.flag = false
            } else {
              // ele.productCode === 'ZKICATM_GRDL_Plan' ? ele.flag = true : ele.flag = false
              ele.flag = false
            }
            ele = this.getProductDetail(ele, agentCode, businessNature)
          })
          this.$store.commit('set_initializeProductXInfoDTOList', newProductXInfoDTOList)
          this.adds = this.adds - 1
        } else {
          this.adds = this.adds - 1
        }
      }).catch(err => {
        console.log(err)
        this.adds = this.adds - 1
      })
    },
    getProductDetail(item, agentCode, businessNature) {
      const planParam = {
        insuredType: this.$store.state.recognizeeIn.insuredNature === '4' ? '2' : '1', // 投保类型 1-个人  2-单位
        businessNature: businessNature, // 业务来源
        agentCode: agentCode, // 代理人代码
        productCode: item.productCode, // 产品代码
        seatCount: this.$store.state.vehicleInfos.seatCount, // 座位数限制
        useNature: this.$store.state.vehicleInfos.useNatureCode, // 车辆使用性质
        carKindCode: this.$store.state.vehicleInfos.carKindCode // 车辆类型编号
      }
      this.$http.post(api.queryProductPlanList, planParam).then(res => {
        if (res.data.rtnCode === '0000' && res.data.productPlanDTOList) {
          // 获取方案计划
          item.productPlanDTOList = res.data.productPlanDTOList
          const schemeParam = {
            planName: item.productPlanDTOList[0].projectName || '',
            planCode: item.productPlanDTOList[0].projectCode || '',
            sumPremium: item.productPlanDTOList[0].sumPremium || '',
            sumAmount: item.productPlanDTOList[0].sumAmount || '',
            commiFee: item.productPlanDTOList[0].commiFee || '',
            riskCode: item.riskCode,
            sumQuantity: '1',
            productCode: item.productCode,
            productName: item.productName
          }
          this.$set(item, 'attachRiskListParam', schemeParam)
          // 若是健康险则需要kindCode
          if (item.productCode === '0666' || item.productCode === '0653' || item.productCode === '0657') {
            item.attachRiskListParam.planCodeDtoList = []
            item.productPlanDTOList[0].kindDtoList.forEach(el => {
              const obj = {
                itemCode: el.itemCode,
                itemName: el.itemName,
                kindCode: el.kindCode,
                kindName: el.kindName
              }
              item.attachRiskListParam.planCodeDtoList.push(obj)
            })
          }
          if (item.productCode === '0666' || item.productCode === '0653') {
            // 有无社保
            item.attachRiskListParam.socialInsurance = '1'
          }
        }
      })
      return item
    },
    getDate() {
      const date = this.$moment(new Date().getTime()).add(1, 'd')
      const year = new Date(date).getFullYear()
      const month = this.filtration(new Date(date).getMonth())
      const daa = this.filtration(new Date(date).getDate())
      const add = new Date() * 1 + 60 * 60 * 1000
      this.minDate = new Date(add)
      this.currentDate = new Date(year, month, daa)
      if (!this.$store.state.baseInfo.startDateCI && !this.$store.state.baseInfo.endDateCI) {
        this.JQStartDate = this.$moment(new Date().getTime()).add(1, 'd').format('YYYY-MM-DD')
        const jqday = this.$moment(this.JQStartDate).subtract(1, 'd').format('YYYY-MM-DD')
        this.JQEndDate = this.$moment(jqday).add(1, 'years').format('YYYY-MM-DD')
      }
      if (!this.$store.state.baseInfo.startDate && !this.$store.state.baseInfo.endDate) {
        this.SYStartDate = this.$moment(new Date().getTime()).add(1, 'd').format('YYYY-MM-DD')
        const syday = this.$moment(this.SYStartDate).subtract(1, 'd').format('YYYY-MM-DD')
        this.SYEndDate = this.$moment(syday).add(1, 'years').format('YYYY-MM-DD')
      }
    },
    // 控制只能输入小数点后2位
    clearNumPrice(e, precision, integerLength, arrData, key, index1, index2) {
      this.price = false
      this.$store.commit('setAlter', '3')
      if (precision === 0) {
        if (e.target.value.length === 1) {
          e.target.value = e.target.value.replace(/[^1-9]/g, '')
        } else {
          e.target.value = e.target.value.replace(/\D/g, '')
          if (e.target.value.length > integerLength) {
            e.target.value = e.target.value.substring(0, integerLength) // 整数只能输入integerLength位
          }
        }
      } else {
        // 修复第一个字符是小数点 的情况.
        if (e.target.value !== '' && e.target.value.substr(0, 1) === '.') {
          e.target.value = ''
        }
        e.target.value = e.target.value.replace(/^0*(0\.|[1-9])/, '$1') // 解决 粘贴不生效
        e.target.value = e.target.value.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
        e.target.value = e.target.value.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
        e.target.value = e.target.value
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.')
        if (e.target.value.indexOf('.') < 0 && e.target.value !== '') {
          // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
          if (e.target.value.substr(0, 1) === '0' && e.target.value.length === 2) {
            e.target.value = e.target.value.substr(1, e.target.value.length)
          }
          if (e.target.value.length > integerLength) {
            e.target.value = e.target.value.substring(0, integerLength) // 整数只能输入integerLength位
          }
        } else {
          const arr = e.target.value.split('.')
          const str1 = arr[0].substr(0, integerLength)
          let str3 = ''
          if (arr[1]) {
            str3 = arr[1].substr(0, parseInt(precision))
            e.target.value = str1 ? `${str1}.${str3}` : ``
          }
        }
      }
      if (typeof index2 === 'number') {
        this[arrData][index1].accessoryRisk[index2][key] = e.target.value
      } else {
        if (key.indexOf('.') > -1) {
          const key1 = key.split('.')[0]
          const key2 = key.split('.')[1]
          this[arrData][index1][key1][key2] = e.target.value
        } else {
          this[arrData][index1][key] = e.target.value
        }
      }
      if (arrData === 'moreServeData') {
        if (e.target.value > 3) {
          this[arrData][index1][key] = ''
          this.$toast('最多只能输入3次')
        }
      }
    },
    // "下一步"的点击函数
    goNext() {
      // 全面保障数据
      const baozhangData = this.$refs.baozhang.validata()
      const attachRiskList = []
      const carPolicySubInfoList = []
      baozhangData.forEach(ele => {
        if (ele.flag) {
          if (ele.sourceFlag === '1') {
            ele.attachRiskListParam.riskCode = ele.riskCode
            attachRiskList.push(ele.attachRiskListParam)
          } else {
            const carPolicySubInfoListParam = {
              address: ele.address,
              quantity: ele.attachRiskListParam.sumQuantity,
              riskCode: ele.riskCode, // 险种代码
              riskName: ele.attachRiskListParam.planName, // 方案名
              insureGradeNo: ele.attachRiskListParam.planCode, // 方案号
              productCode: ele.productCode, // 产品名称
              productName: ele.productName, // 产品代码
              sumAmount: ele.attachRiskListParam.sumAmount,
              sumPremium: ele.attachRiskListParam.sumPremium
            }
            carPolicySubInfoList.push(carPolicySubInfoListParam)
          }
        }
      })
      if ((!this.isQD && this.price && !this.$store.state.variation) ||
        (this.isQD && this.taxRelifInfo.taxRegistryNumber && !this.isChange && this.price && !this.$store.state.variation)) {
        this.adds += 1
        const data = {
          orderId: this.$store.state.orderId,
          terminalId: localStorage.getItem('setTerminalId'),
          orderOrigin: localStorage.getItem('setChannelCode'),
          channelCode: localStorage.getItem('setChannelCode'),
          terminalIdType: checkFormat.getPhoneLike(),
          attachRiskList: attachRiskList,
          carPolicySubInfoList: carPolicySubInfoList,
          baseInfo: this.$store.state.baseInfo
        }
        if (this.basePart.isDjq) {
          data.baseInfo.isDjq = this.basePart.isDjq
        }
        this.$http.post(api.save, data).then(res => {
          Toast.clear()
          if (res.data.rtnCode === '0000') {
            this.$store.commit('setStep', '4')
            this.$store.commit('setCalculateFlag', this.calculateFlag)
            this.$store.commit('setSumPremium', this.sumPremium)
          } else {
            Toast.clear()
            this.$toast(res.data.rtnMsg)
          }
          this.adds = this.adds - 1
        }).catch(err => {
          this.$toast('请求失败')
          console.log(err)
          this.adds = this.adds - 1
        })
      } else {
        if (this.isQD && this.taxRelifInfo.taxRegistryNumber && this.isChange) {
          Toast('您修改了“税务登记证号”，请重新报价')
        } else if (this.isQD && this.OldTaxRegistryNumber && !this.taxRelifInfo.taxRegistryNumber) {
          Toast('请填写“税务登记证号”并重新报价')
        } else {
          Toast('请先执行报价')
        }
      }
    },
    // 分享
    share() {
      if (this.price && !this.$store.state.variation) {
        this.adds += 1
        const data = {
          orderId: this.$store.state.orderId,
          terminalId: localStorage.getItem('setTerminalId'),
          orderOrigin: localStorage.getItem('setChannelCode'),
          channelCode: localStorage.getItem('setChannelCode'),
          carPolicySubInfoList: []
        }
        if (this.isShowSJY) {
          const datas = {
            insureGradeNo: this.scheme.code,
            riskName: this.scheme.text,
            quantity: '1', // 保险份数
            riskCode: this.scheme.riskCode,
            sumAmount: this.scheme.sumAmount,
            sumPremium: this.scheme.sumPremium,
            commiFee: this.scheme.commiFee
          }
          if (configure.allChannelCode.indexOf(localStorage.getItem('setChannelCode')) > -1) {
            data.carPolicySubInfoList.push(datas)
          }
        }
        this.$http.post(api.save, data).then(res => {
          Toast.clear()
          if (res.data.rtnCode === '0000') {
            const URL = window.location.href
            const shareUrl = `https://${window.location.host}/app/mall/car-proposal/#/ShareQuote?orderId=${this.$store.state.orderId}&discount=${this.discount}`
            if (URL.indexOf('terminalId=APP') !== -1) {
              const param = {
                title: '车险报价',
                url: shareUrl
              }
              ShowShareBtn.postMessage(JSON.stringify(param))
            } else {
              this.isPop = true
              const that = this
              wx.ready(function() {
                // 分享给好友
                wx.updateAppMessageShareData({
                  title: '车险报价', // 分享标题
                  desc: '紫金保险销售有限公司移动展业平台', // 分享描述
                  link: shareUrl, // 分享链接
                  imgUrl: that.shareLogo, // 分享图标
                  success: function() {
                  },
                  cancel: function() {
                  }
                })
              })
            }
          } else {
            Toast.clear()
            this.$toast(res.data.rtnMsg)
          }
          this.adds = this.adds - 1
        }).catch(err => {
          this.$toast('请求失败')
          console.log(err)
          this.adds = this.adds - 1
        })
      } else {
        Toast('请先执行报价')
      }
    },
    // 获取签名
    getTicket() {
      const param = {
        url: window.location.href.split('#')[0],
        wxType: '5'
      }
      this.adds += 1
      this.$http
        .post(api.getWxTicket, param)
        .then(res => {
          wx.config({
            beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: api.appId, // 必填，企业微信的corpID
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
            jsApiList: ['updateAppMessageShareData'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
          })
          this.adds = this.adds - 1
        })
        .catch(error => {
          console.log(error)
          this.adds = this.adds - 1
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/car/newQuote/Mixin/checkMixin.js